import { AUDIO } from '../core/SimConfig.js';

export const EngineStatus = {
  OFF: 'OFF',
  STARTING: 'STARTING',
  ON: 'ON',
  STOPPING: 'STOPPING',
};

export default class EngineState {
  constructor(startOn = false) {
    this.status = startOn ? EngineStatus.ON : EngineStatus.OFF;
    this._timer = 0;
    this._duration = 0;
  }

  get isRunning()       { return this.status === EngineStatus.ON; }
  get isOff()           { return this.status === EngineStatus.OFF; }
  get isTransitioning() { return this.status === EngineStatus.STARTING || this.status === EngineStatus.STOPPING; }
  get isStarting()      { return this.status === EngineStatus.STARTING; }
  get isStopping()      { return this.status === EngineStatus.STOPPING; }

  /** 0→1 progress through the current startup/shutdown sequence. */
  get transitionProgress() {
    if (!this.isTransitioning) return this.isRunning ? 1 : 0;
    return Math.min(this._timer / this._duration, 1);
  }

  toggle() {
    if (this.isTransitioning) return; // ignore during sequence

    if (this.status === EngineStatus.OFF) {
      this.status = EngineStatus.STARTING;
      this._duration = AUDIO.startup.duration;
      this._timer = 0;
    } else if (this.status === EngineStatus.ON) {
      this.status = EngineStatus.STOPPING;
      this._duration = AUDIO.shutdown.duration;
      this._timer = 0;
    }
  }

  update(dt) {
    if (!this.isTransitioning) return;

    this._timer += dt;
    if (this._timer >= this._duration) {
      this.status = this.isStarting ? EngineStatus.ON : EngineStatus.OFF;
      this._timer = 0;
    }
  }
}
